module.exports = __webpack_public_path__ + "img/drug-13.edfa7bca.png";